import { render, staticRenderFns } from "./AdditionalFeeApplication.vue?vue&type=template&id=39148130&"
import script from "./AdditionalFeeApplication.vue?vue&type=script&lang=js&"
export * from "./AdditionalFeeApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39148130')) {
      api.createRecord('39148130', component.options)
    } else {
      api.reload('39148130', component.options)
    }
    module.hot.accept("./AdditionalFeeApplication.vue?vue&type=template&id=39148130&", function () {
      api.rerender('39148130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/AdditionalFeeApplication.vue"
export default component.exports